// extracted by mini-css-extract-plugin
export default {"ButtonContainerCenter":"Buttons_ButtonContainerCenter__TJZUl","DefaultButton":"Buttons_DefaultButton__G9o2r"};